import { render } from "./draggable.vue?vue&type=template&id=79ff2fba&ts=true"
import script from "./draggable.vue?vue&type=script&lang=ts"
export * from "./draggable.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\web project\\vue3-tree-org\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__